'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.siteLanguage = twentyninetimes.siteLanguage || function () {

	function init() {
		let languageWrapper = document.getElementById('js-site-language');

		if ( languageWrapper && "ontouchstart" in document.documentElement ) 
      site_language(languageWrapper);
	}

	function site_language(wrapper) { 
    var toggle = wrapper.querySelector('.js-site-language-toggle'),
        body = document.body;

    toggle.addEventListener('click', function(e) {
      e.stopPropagation;

      if ( !body.classList.contains('lang-active') ) {
        body.classList.add('lang-active');
      } else {
        body.classList.remove('lang-active');
      }
    });
	}

	return {
		init : init
	};

}();